module.exports = __webpack_public_path__ + "img/INF-B-1-I.d63b87a3.png";